import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';

export interface AppointmentNotification {
  pid: number;
  data?: any;
  // Add other properties as needed
}

@Injectable({
  providedIn: 'root'
})

export class AppointmentNotificationService {

  _url= 'https://ciot.appointele.com/api';
  private eventSource: EventSource | null = null;
  private notificationSubject = new Subject<any>();
  private reconnectAttempts = 0;
  private maxReconnectAttempts = 5;
  private reconnectDelay = 5000; // 5 seconds
  
  public notification$ = this.notificationSubject.asObservable();
  
  constructor(private zone: NgZone) {}
  
  // Start listening for notifications
  startListening(userId: number, role: string, branch: string) {
    this.reconnectAttempts = 0;
    this.listenForNotifications(userId, role, branch);
  }
  
  private listenForNotifications(userId: number, role: string, branch: string) {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
    
    this.zone.runOutsideAngular(() => {
      // Create new EventSource connection
      this.eventSource = new EventSource(`https://ciot.appointele.com/api/appointment_notification_get.php?username=${userId}&role=${role}&branch=${branch}`);
      
      this.eventSource.onopen = () => {
        console.log("SSE connection opened");
        this.reconnectAttempts = 0; // Reset reconnect attempts on successful connection
      };
      
      this.eventSource.addEventListener('notification', (event: MessageEvent) => {
        try {
          const notification = JSON.parse(event.data);
          
          this.zone.run(() => {
            this.notificationSubject.next(notification);
          });
        } catch (error) {
          console.error("Error parsing notification data:", error);
        }
      });
      
      this.eventSource.onerror = (error) => {
        console.error("SSE connection error:", error);
        this.eventSource?.close();
        this.eventSource = null;
        
        // Implement reconnection with exponential backoff
        if (this.reconnectAttempts < this.maxReconnectAttempts) {
          this.reconnectAttempts++;
          const delay = this.reconnectDelay * Math.pow(2, this.reconnectAttempts - 1);
          
          console.log(`Attempting to reconnect in ${delay / 1000} seconds...`);
          setTimeout(() => {
            this.listenForNotifications(userId, role, branch);
          }, delay);
        } else {
          console.error("Max reconnection attempts reached. Please manually reconnect.");
        }
      };
    });
  }
  
  // Close connection when no longer needed
  stopListening() {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }
}